import { useNavigate } from "react-router-dom";
import { NotFoundCanvas } from "../components/not-found-canvas";
import { Button } from "../components/ui/button";

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="relative flex min-h-dvh flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <NotFoundCanvas />
      </div>
      <div className="relative z-10 flex flex-col items-center px-6 text-center">
        <p className="mb-5 font-mono text-xs uppercase tracking-[0.24em] text-muted-foreground">
          Error 404
        </p>
        <h1 className="font-serif text-[clamp(72px,14vw,144px)] font-medium italic leading-[0.95] tracking-[-0.04em]">
          Lost.
        </h1>
        <p className="mt-7 max-w-[34em] text-[clamp(15px,2vw,17px)] leading-relaxed text-muted-foreground">
          This page doesn&apos;t exist. Head back to the dashboard and
          you&apos;ll find your way to the right place.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <Button size="lg" onClick={() => navigate("/")}>
            Back to dashboard →
          </Button>
          <Button size="lg" variant="outline" onClick={() => navigate(-1)}>
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
}
